import { connect } from "react-redux"
import View from "./view"
import { Store } from "utilities/Redux/store"
import { getCompletedOfferRequestIdsForBuyer } from "modules/Buyer/OfferRequests/selectors"

const mapStateToProps = (state: Store) => ({
  historyOfferRequestIds: getCompletedOfferRequestIdsForBuyer(state),
})

export default connect(mapStateToProps)(View)
